import { get } from 'vuex-pathify';
export default {
  computed: {
    dmaDataSourceName: get('admin/modulesMapping@billing.dma_datasource_name'),
    dmaLayerId: get('admin/modulesMapping@billing.dma_layer_id'),
  },
  methods: {
    isTopologicalDataSource({ name: dataSourceName, scope: dataSourceScope } = {}) {
      return (
        (dataSourceScope === 'water' || dataSourceScope === 'sewer') &&
        (!this.dmaDataSourceName || dataSourceName !== this.dmaDataSourceName)
      );
    },
    isTopologicalLayer({ id: layerId, layer_scope: layerScope } = {}) {
      return (layerScope === 'water' || layerScope === 'sewer') && (!this.dmaLayerId || layerId !== this.dmaLayerId);
    },
  },
};
